export const languagesList = [
  {
    label: 'English',
    value: 'en',
  },
  {
    label: 'Indonesian',
    value: 'id',
  },
  {
    label: 'Arabic',
    value: 'ar',
  },
  {
    label: 'Thai',
    value: 'th',
  },
  {
    label: 'Portuguese',
    value: 'pt',
  },
  {
    label: 'Malay',
    value: 'ms',
  },
  {
    label: 'Spanish',
    value: 'es',
  },
  {
    label: 'Vietnamese',
    value: 'vi',
  },
  {
    label: 'Japanese',
    value: 'ja',
  },
  {
    label: 'French',
    value: 'fr',
  },
  {
    label: 'Uzbek',
    value: 'uz',
  },
  {
    label: 'Kiswahili',
    value: 'sw',
  },
]
export const categoryList = [
  {
    label: 'Untrusted',
    value: 'untrusted',
  },
  {
    label: 'Normal',
    value: 'normal',
  },
  {
    label: 'Trusted',
    value: 'trusted',
  },
]
